import {ServerError} from '../ServerError'
import {FetchFunction} from '../types'

const USER_ID_HEADER = 'x-yataxi-userid'

function withStartup<TReq = unknown, TRes = unknown>(fetchFn: FetchFunction<TReq, TRes>): FetchFunction<TReq, TRes> {
  let _userID: string = ''
  let _promise: Promise<void> | null = null

  const _withStartup: FetchFunction<TReq, TRes> = config => {
    if (_userID) {
      return fetchFn({
        ...config,
        headers: {
          ...config?.headers,
          [USER_ID_HEADER]: _userID,
        },
      })
    }

    if (_promise === null) {
      _promise = fetchFn({
        ...config,
        body: undefined,
        url: '/4.0/startup',
        method: 'post',
        options: {
          credentials: 'include',
        },
      }).then(response => {
        _promise = null

        if (!response.headers[USER_ID_HEADER]) {
          throw new ServerError({
            // @ts-expect-error кривая типизация у ошибки
            error: new Error('empty header user id'),
            status: 500,
            body: response.body,
            headers: response.headers,
          })
        }

        _userID = response.headers[USER_ID_HEADER]
      })
    }

    return _promise.then(() => _withStartup(config))
  }

  return _withStartup
}

export default withStartup
